export const extractBaseLang = (lang: string) => {
  const [baseLang] = lang.split("-");
  return baseLang;
};
